<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data style="margin-top:10px;"
        [title]="'spACE-AR Automated Recurring Task Report'"
        [lotNumber]="_appGeneralState.currentLotNumber"
        [lotName]="_appGeneralState.currentLotName"
    ></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 700px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>
                <form 
                (ngSubmit)="onSubmitAsOfWebJobsDataFetch()" 
                novalidate
                [formGroup]="webJobsForm" 
                style="margin-top:20px;">
            <div class="row" style="width:100%;">
                <div class="col-6">
                    <mat-form-field style="width:100%;color:gray">
                        <mat-label>Choose report start date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="reportDate">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                </div>
                <div class="col-1">
                    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!webJobsForm.valid">Search</button>
                    <!-- <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" (click)="exportButtonHandler()">Export</button> -->
                </div>
            </div>
        </form>


        <ng-container *ngIf="this.jobReportData.length == 0">
            <p>No report data available for the selected start date.</p>
        </ng-container>
    <ng-container *ngIf="this.jobReportData.length > 0">
        <div style="margin-top:30px;"></div>
    
        <igx-grid #gridAgingReport id="gridAgingReport" [igxPreventDocumentScroll]="true" [data]="jobReportData "  [height]="'720px'" [width]="'100%'" [autoGenerate]="false"
        [primaryKey]="'jobRunId'" [cellSelection]="'none'" [rowEditable]="false">

        <igx-column field="status" header=" "  width="75px" [sortable]="true">
            <ng-template igxCell let-cell="cell">
                @if(cell.value == 0){
                    <mat-icon style="color:red;">error</mat-icon>
                }
                @else if(cell.value == 1){
                    <mat-icon style="color:green;">check</mat-icon>
                }
                @else if(cell.value == 2){
                    <mat-icon style="color:red;">check</mat-icon>
                }
                @else if(cell.value == 3){
                    <mat-icon style="color:red;">cancel</mat-icon>
                }
                @else if(cell.value == 4){
                    <mat-icon style="color:green;">run_circle</mat-icon>
                }
            </ng-template>
        </igx-column>
        <igx-column field="jobRunId" header="Id"  width="75px" [sortable]="true"></igx-column>
        <igx-column field="officialJobName" header="Report Name"  width="325px" [sortable]="true"></igx-column>
        <igx-column field="jobStartDateTimeUtc" header="Start Date" width="175px" dataType="date" [sortable]="true" >
            <ng-template igxCell let-cell="cell">
                {{ cell.value | date:'MM/dd/yy hh:mm a' }}
            </ng-template>
        </igx-column>
        <igx-column field="jobFinishDateTimeUtc" header="Finish Date" width="175px" required dataType="date" [sortable]="true" >
            <ng-template igxCell let-cell="cell">
                {{ cell.value | date:'MM/dd/yy hh:mm a' }}
            </ng-template>
        </igx-column>
        <igx-column field="lastSuccessfulRunDateUtc" header="Last Successful Run Date" width="250px" required dataType="date" [sortable]="true" >
            <ng-template igxCell let-cell="cell">
                {{ cell.value | date:'MM/dd/yy hh:mm a' }}
            </ng-template>
        </igx-column>
        <igx-column field="statusMessage" header="Status" width="225px" required [sortable]="true" ></igx-column>
        <igx-column field="comments" header="Comments" width="250px" required [sortable]="true" ></igx-column>

    <igx-grid-toolbar>
    <igx-grid-toolbar-actions>
    <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
    <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
    <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
    </igx-grid-toolbar-actions>
    </igx-grid-toolbar>


    </igx-grid>


    </ng-container>

</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    
</mat-card-actions>

</mat-card>                                                                             

</div>

